import { createTheme } from "@mui/material";

export const customTheme = createTheme({
  typography: {
    // Titillium has no syllabics, so Inuktitut falls through to Noto.
    fontFamily: `'Titillium Web', 'Noto Sans Canadian Aboriginal', 'Roboto', 'Helvetica', 'Arial', sans-serif`,
    fontWeightRegular: 600,
    body1: {
      fontSize: "1.25rem",
    },
    h1: {
      fontSize: "1.8rem",
    },
    h2: {
      fontSize: "1.6rem",
    },
    h3: {
      fontSize: "1.4rem",
    },
    h4: {
      fontSize: "1.2rem",
    },
    h5: {
      fontSize: "1rem",
    },
  },
  palette: {
    common: {
      black: "#32302F",
      white: "#fff",
    },
    primary: {
      main: "#1c1c1c",
      dark: "#161519",
      // main: "#fff",
    },
    quoteCard: {
      background: "#161519",
    },
    neutralAlpha: {
      white55: "rgba(255, 255, 255, 0.55)",
      white45: "rgba(255, 255, 255, 0.45)",
      white30: "rgba(255, 255, 255, 0.3)",
    },
    secondary: {
      main: "#E5E5E5",
    },
    warning: {
      main: "#FCA311",
      dark: "#c07c33",
      contrastText: "#fff",
    },
    info: {
      main: "#14213D",
    },
  },
  components: {
    MuiDrawer: {
      styleOverrides: {
        paper: {
          background: "#32302F",
          color: "#FFF",
          // A flat 350px is wider than the narrowest phones.
          width: "min(350px, 100vw)",
        },
      },
    },
  },
});
